import React, { useState, useEffect } from "react";
import { Select } from "antd";
import {
  parseFormControlValue,
  checkEmptyObject,
  showDropdownSearch,
  getWindowWidth
} from "../../../services/utils";
import { InputType } from "../../../models/enums";
import { isSearchMobile } from "../../../services";

import MobileDropdownSelect from "./MobileDropdownSelect";
import styles from "./singleColorSelector.scss";

const SingleColorSelector = props => {
  const {
    options: propOptions,
    value: propValue,
    field,
    placeholder = "Odaberite",
    title = "",
    isRequired = false,
    valueType = "",
    hasAnyValue = false,
    anyTitle = "Poništi",
    className = "",
    style = {},
    onChange,
    isDisabled = false
  } = props;

  const handleBooleanValue = (value, valueType) => {
    if (valueType === InputType.boolean) {
      return value ? 1 : 0;
    }

    return value;
  };

  const getValue = (value, field, valueType) => {
    if (checkEmptyObject(value)) {
      return handleBooleanValue(value[field], valueType);
    }

    // need to return undefined here because antd's Select only show placeholder if the value is undefined.
    return undefined;
  };

  const [options, setOptions] = useState(propOptions);
  const [value, setValue] = useState(getValue(propValue, field, valueType));

  useEffect(() => {
    if (
      !hasAnyValue &&
      propOptions !== options &&
      propValue &&
      !value &&
      propOptions.length > 0
    ) {
      const values = propOptions.map(opt => opt.value);
      if (!values.includes(propValue[field])) {
        onChange({ [field]: undefined });
      }
    }

    setOptions(propOptions);
    setValue(getValue(propValue, field, valueType));
  }, [propOptions, propValue, field, valueType]);

  const handleChange = option => {
    let newValue = option;

    if (newValue !== "") {
      if (valueType === InputType.boolean) {
        newValue = Boolean(newValue);
      }
    } else {
      onChange({ [field]: "" });
      return;
    }

    onChange(parseFormControlValue([field], [newValue]));
  };

  const handleSearch = (input, option) =>
    option && option.props && option.props.children &&
    typeof option.props.children === "string" &&
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  const showSearch = () => {
    const anyOptionValue = hasAnyValue ? 1 : 0;
    const optionsCount = options.length + anyOptionValue;

    return showDropdownSearch(optionsCount);
  };

  const allOptions = options.map(o => ({
    ...o,
    value: handleBooleanValue(o.value, valueType)
  }));

  if (hasAnyValue && value) {
    allOptions.unshift({
      title: anyTitle,
      value: "",
      style: {
        borderBottom: "1px solid #e8e8e8"
      }
    });
  }

  if (isSearchMobile(getWindowWidth())) {
    return (
      <span style={style}>
        <span
          className={`control-title ${isRequired ? "required" : ""} ${
            styles.label
          }`}
        >
          {title}
        </span>
        <MobileDropdownSelect
          options={allOptions}
          value={value}
          valueType={valueType}
          placeholder={placeholder}
          isDisabled={isDisabled}
          onChange={handleChange}
          title={title}
        />
      </span>
    );
  }

  return (
    <span className={className} style={style}>
      <span className={`control-title ${isRequired ? "required" : ""}`}>
        {title}
      </span>
      <Select
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={isDisabled}
        showSearch={showSearch()}
        optionFilterProp="children"
        filterOption={handleSearch}
      >
        {allOptions.map((option, index) => (
          <Select.Option
            key={index /* eslint-disable-line */}
            value={option.value}
            style={option.style || {}}
          >
            {option.title}
          </Select.Option>
        ))}
      </Select>
    </span>
  );
};

export default SingleColorSelector;



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleColorSelector/SingleColorSelector.tsx